import { DTOClocks } from '../../DTO/Reportes/DTOClocks';
import { DTOEntradasSalidasRango } from '../../Componest/Catalogos/CatalogosReloj/DTO/DTOEntradasSalidasRango';
import { DTOReporteChecadas } from '../../Componest/Catalogos/CatalogosReloj/DTO/DTOReporteChecadas';
import { DTOGestionChecadasParams } from '../../Componest/Catalogos/CatalogosReloj/DTO/DTOGestionChecadasParams';
import { DTOReporteFechas } from '../../Componest/Catalogos/CatalogosReloj/DTO/DTOReporteFechas';
import http from '../common/http-common';
import DTOChecadaHomeOffice, { DTOChecadaHomeOfficeAgrupada } from '../../DTO/DTOEsHomeParams';

class RelojChecadorDataService {
  
  // Endpoint para obtener checadas del día actual
  getEntradasSalidasHoy(fecha?: string | null) {
    const params = fecha ? `?fecha=${fecha}` : '';
    return http.get<Array<DTOClocks>>(`/Reportes/GetEntradasSalidasHoy${params}`);
  }

  // Endpoint para obtener checadas por rango de fechas
  getRptEntradasSalidasRango(FechaInicio: string, FechaFin: string) {
    return http.get<Array<DTOEntradasSalidasRango>>(
      `/Reportes/EntradasSalidaRango?FechaInicio=${FechaInicio}&FechaFin=${FechaFin}`
    );
  }

  // Nuevos endpoints para gestión de checadas
  getReporteChecadas(fechaInicio?: string, fechaFin?: string) {
    const params = new URLSearchParams();
    if (fechaInicio) params.append('fechaInicio', fechaInicio);
    if (fechaFin) params.append('fechaFin', fechaFin);
    
    return http.get<Array<DTOReporteChecadas>>(
      `/Reportes/EntradasSalidasInicioYFin?${params.toString()}`
    );
  }


   getReporteChecadasSupervisor(idSupervisor: string, fechaInicio?: string, fechaFin?: string) {
    const params = new URLSearchParams();
    
    
    params.append('idSupervisor', idSupervisor);
    
    if (fechaInicio) params.append('fechaInicio', fechaInicio);
    if (fechaFin) params.append('fechaFin', fechaFin);
    
    return http.get<Array<DTOReporteChecadas>>(
      `/Reportes/ReporteHorasXSupervisor?${params.toString()}`
    );
}




  getEntradasSalidasFechas(fechaInicio? : string, fechaFin? :string) 
  {
    const params = new URLSearchParams();
    if (fechaInicio) params.append('fechaInicio', fechaInicio);
    if (fechaFin) params.append('fechaFin', fechaFin);
    
    return http.get<Array<DTOReporteFechas>>(
      `/Reportes/EntradasSalidasFechas?${params.toString()}`
    );
  }


   getEntradasSalidasFechasSupervisor(idSupervisor: string, fechaInicio?: string, fechaFin?: string) 
  {
    const params = new URLSearchParams();
    
    
    params.append('idSupervisor', idSupervisor);
    
    if (fechaInicio) params.append('fechaInicio', fechaInicio);
    if (fechaFin) params.append('fechaFin', fechaFin);
    
    return http.get<Array<DTOReporteFechas>>(
        `/Reportes/ReporteHorasSemanalXSupervisor?${params.toString()}`
    );  
  }





  

  // Método unificado para gestionar checadas (agregar/editar/eliminar)
  gestionarChecada(params: DTOGestionChecadasParams) {
    return http.post<DTOReporteChecadas[]>(
      `/Reportes/EntradasSalidas${params.Accion}`,
      params
    );
  }

  // Métodos específicos para mejor semántica
  agregarChecada(params: Omit<DTOGestionChecadasParams, 'accion'>) {
    return this.gestionarChecada({ ...params, Accion: 'AGREGAR' });
  }

  editarChecada(params: Omit<DTOGestionChecadasParams, 'accion'>) {
    return this.gestionarChecada({ ...params, Accion: 'EDITAR' });
  }

//   editarChecada(params: Omit<DTOGestionChecadasParams, 'Accion'>) {
//     return this.gestionarChecada({ ...params, Accion: 'EDITAR' });
// }

  eliminarChecada(params: Omit<DTOGestionChecadasParams, 'accion'>) {
    return this.gestionarChecada({ ...params, Accion: 'ELIMINAR' });
  }



  // GetChecadasHomeOffice(numEmpleado: string, fechaInicio?: Date | null, fechaFin?: Date | null) {
  //   return http.get<DTOChecadaHomeOffice[]>('/Reportes/HomeOfficeChecadas', {
  //     params: {
  //       numEmpleado: numEmpleado,
  //       fechaInicio: fechaInicio ? fechaInicio.toISOString() : null,
  //       fechaFin: fechaFin ? fechaFin.toISOString() : null
  //     }
  //   });
  // }

  GetChecadasHomeOffice(
  numEmpleado: string,
  fechaInicio?: Date | null,
  fechaFin?: Date | null
) {
  return http.get<DTOChecadaHomeOfficeAgrupada[]>(
    '/Reportes/HomeOfficeChecadas',
    {
      params: {
        numEmpleado: numEmpleado,
        fechaInicio: fechaInicio ? fechaInicio.toISOString() : undefined,
        fechaFin: fechaFin ? fechaFin.toISOString() : undefined
      }
    }
  );
}

  // POST: Insertar checada Home Office
  PostAgregarChecadaHomeOffice(data: {
    NumEmpleado: string;
    CheckTime: string; // o Date, pero envíalo como ISO string
    CheckType: 'I' | 'O';
    UsuarioOperacion: number;
    Comentario?: string;
  }) {
    return http.post<DTOChecadaHomeOffice[]>('/Reportes/HomeOfficeAgregar', data);
  }

  // POST: Actualizar checada Home Office
  PostActualizarChecadaHomeOffice(data: {
    Id: number;
    NumEmpleado: string;
    CheckTime: string;
    CheckType: 'I' | 'O';
    UsuarioOperacion: number;
    Comentario?: string;
    ComentarioNuevo?: string;
  }) {
    return http.post<DTOChecadaHomeOffice[]>('/Reportes/HomeOfficeActualizar', data);
  }

  // POST: Eliminar checada Home Office
  PostEliminarChecadaHomeOffice(data: {
    Id: number;
    NumEmpleado: string;
    UsuarioOperacion: number;
    Comentario?: string;
  }) {
    return http.post<DTOChecadaHomeOffice[]>('/Reportes/HomeOfficeEliminar', data);
  }








}

export default new RelojChecadorDataService();